export enum MainOwnerSelectionEnum {
  Coowner1 = 'mainOwnerSelection.coowner1',
  MainOwner = 'mainOwnerSelection.mainOwner',
}
